module.exports = __webpack_public_path__ + "img/copertina_fed_base.d53ddce6.jpg";